import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { SearchIcon } from 'components/Icon';
import { CloseButton } from 'components/buttons/CloseButton/CloseButton';
import { useAppContext } from 'contexts/appContext';
import { ListFilterOption } from 'lib/apiClient';

import styles from './FilterSearchBar.css';

import { useMemo, useState } from 'react';

export interface FiltersSearchBarProps {
	searchData: ListFilterOption[];
	filterKey: string;
}

export function FiltersSearchBar({ searchData, filterKey }: Readonly<FiltersSearchBarProps>) {
	const { updateSelection } = useFiltersContext();
	const { dictionary } = useAppContext();
	const [searchValue, setSearchValue] = useState<string>('');

	const { inputPortsLabel, inputPortsPlaceholder } = dictionary;

	const optiontoShow = useMemo(() => {
		return searchData?.filter((item) => item.label.toLowerCase().includes(searchValue) && item.label !== searchValue) || [];
	}, [searchData, searchValue]);

	const handleSearchSelected = (element: ListFilterOption) => {
		updateSelection(filterKey, { value: [element.code] });
		setSearchValue('');
	};

	const onValueChange = (value: string) => {
		setSearchValue(value.toLowerCase());
	};

	const handleCloseClick = () => {
		setSearchValue('');
	};

	return (
		<div className={styles.root}>
			<label className={styles.searchBarLabel}>{inputPortsLabel}</label>
			<div className={styles.searchBar}>
				<input
					data-testid={`search-for-${filterKey}-input`}
					className={styles.searchInput}
					type="text"
					onChange={(e) => onValueChange(e.target.value)}
					value={searchValue}
					placeholder={inputPortsPlaceholder}
				/>
				<div className={styles.buttonContainer}>
					{searchValue ? (
						<CloseButton testId="close-searchBar-filter-button" onClick={handleCloseClick} />
					) : (
						<SearchIcon className={styles.searchIcon} />
					)}
				</div>
			</div>
			{searchValue?.length > 1 && optiontoShow?.length > 0 && (
				<div className={styles.searchDropdown}>
					{optiontoShow.map((port) => (
						<button key={port.code} className={styles.dropdownOption} onClick={() => handleSearchSelected(port)}>
							{port.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
}
